import classes from "./SubsystemList.module.css";
import { useContext, useEffect, useState } from "react";
import MapLefttPanelContentEntity from "../../Map/leftPanelContent/Entity/MapLefttPanelContentEntity";
import { useStore } from "../../../hooks/store";
import { useHistory, useLocation } from "react-router-dom";
import { showEnvironmentAddress } from "../../../../SMARTCITY/hardCodeData/DATA";
import { SensorIdContext } from "../../../hooks/SensorIdProvider";
import styled from "styled-components";
import { ParkingTypeContext } from "../../../hooks/ParkingTypeProvider";
// import { MobilityContext } from "../../../hooks/MobilityProvider";
import { useAllContexts } from "../../../hooks/useAllContexts";
import { useTranslation } from "react-i18next";

import SvgRecycleBinFull from "../../../assets/icons/RecycleBinFull.svg";
import SvgRecycleBinEmpty from "../../../assets/icons/RecycleBinEmpty.svg";
import SvgRecycleBinLow from "../../../assets/icons/RecycleBinLow.svg";

const SubSystemList = ({
  showAnimation,
  filterTypeName,
  filtersVars,
  mobilityMap,
  setFiltersVars,
  selectedRoad,
}) => {
  const [selectSubSystem, setSelectSubSystem] = useState("");
  const [activeType, setActiveType] = useState(null);
  const [sensors, setSensors] = useState([]);
  const [icons, setIcons] = useState([]);
  const state = useStore()[0];

  const [currentData, setCurrentData] = useState([]);
  const [currentLoading, setCurrentLoading] = useState(false);
  const [extraLoading, setExtraLoading] = useState(false);

  const [filteredSensors, setFilteredSensors] = useState([]);

  const history = useHistory();
  const { search } = useLocation();
  const { pathname } = useLocation();

  const sensorId = useContext(SensorIdContext);

  const {
    environment,
    meteo,
    parking,
    publicParking,
    hydro,
    mesh,
    allSensors,
    variables,
    mobility,
    bins,
  } = useAllContexts();

  const { t } = useTranslation();

  const { mobilityData } = mobility;
  const { showMobility, getSensorFilters } = variables;

  const currTypeURL = new URLSearchParams(search).get("typeId");

  useEffect(() => {
    switch (currTypeURL) {
      case "1": {
        setCurrentLoading(environment.environmentalLoading);
        if (getSensorFilters.length > 0) {
          const tempSensors = [];
          environment.environmentalData.forEach((sensor) => {
            sensor.details.forEach((detail) => {
              if (getSensorFilters.includes(detail.sensorvar_description)) {
                const sensorExists = tempSensors.find(
                  (s) => s.mysensor_id === sensor.mysensor_id,
                );
                if (!sensorExists) {
                  tempSensors.push(sensor);
                }
              }
            });
          });

          setCurrentData(tempSensors);
        } else {
          console.log("TEST: tempSensors:", environment.environmentalData);
          setCurrentData(environment.environmentalData);
        }
        break;
      }
      case "2": {
        setCurrentLoading(mesh.loading);
        setCurrentData(mesh.MeshData);
        break;
      }
      case "9": {
        setCurrentLoading(bins.loading);
        setCurrentData(bins.binsData);
        break;
      }
      case "5": {
        setCurrentLoading(meteo.meteoLoading);

        if (getSensorFilters.length > 0) {
          const tempSensors = [];
          meteo.meteoInfoData.forEach((sensor) => {
            sensor.details.forEach((detail) => {
              if (getSensorFilters.includes(detail.sensorvar_description)) {
                const sensorExists = tempSensors.find(
                  (s) => s.mysensor_id === sensor.mysensor_id,
                );
                if (!sensorExists) {
                  tempSensors.push(sensor);
                }
              }
            });
          });

          console.log("TEST: tempSensors:", tempSensors);
          setCurrentData(tempSensors);
        } else {
          console.log("TEST: tempSensors:", meteo.meteoInfoData);
          setCurrentData(meteo.meteoInfoData);
        }

        break;
      }
      case "6": {
        setCurrentLoading(hydro.hLoading);
        setCurrentData(hydro.hydroData);
        break;
      }
      case "24": {
        if (showMobility) {
          setCurrentData(mobilityData);
        } else {
          setCurrentLoading(parking.loadingParkingDetails);
          setCurrentData(parking.parkingDetailsData ?? []);
        }
        break;
      }
      default: {
        if (allSensors?.allSensorsData) {
          setCurrentLoading(allSensors?.loading);
          setCurrentData(
            allSensors?.allSensorsData?.[currTypeURL]?.data ??
              allSensors?.allSensorsData[currTypeURL],
          );
        } else {
          setCurrentData([]);
          setCurrentLoading(false);
        }
        break;
      }
    }
  }, [
    environment,
    meteo.meteoLoading,
    parking.loadingParkingDetails,
    publicParking.publicLoadingParking,
    hydro.hLoading,
    mesh.loading,
    allSensors?.[currTypeURL]?.loading,
    parking.parkingDetailsData,
    showMobility,
    getSensorFilters,
    currTypeURL,
    bins.loading,
  ]);

  // useEffect(() => {
  //   // console.log("TEST: currTypeURL!!s", currTypeURL);

  //   const tempTypeIdActive = state.types.filter(
  //     (item) => item.id === currTypeURL
  //   );

  //   setActiveType(tempTypeIdActive[0]);

  //   const data = mobilityMap
  //     ? mobility?.mobilityData
  //     : state.sensors?.filter((sensor) => sensor.typeId === currTypeURL);

  //   setSensors(data);

  //   filterData(data);
  // }, [
  //   filterTypeName,
  //   filtersVars,
  //   search,
  //   state.sensors,
  //   state.types,
  //   currTypeURL,
  //   mobilityMap,
  // ]);

  const filterData = (data) => {
    let tempSensors = data;

    if (filterTypeName) {
      tempSensors = sensors.filter((sensor) => {
        return sensor.title.toLowerCase() === filterTypeName.toLowerCase();
      });
    }
    if (filtersVars.length > 0) {
      switch (currTypeURL) {
        case "9": {
          for (let filterVar of filtersVars) {
            switch (filterVar) {
              case "Άδειοι":
                tempSensors = sensors.filter(
                  (sensor) => sensor.metrics[4] <= "25%",
                );
                break;
              case "Κάτω από τη μέση":
                tempSensors = sensors.filter(
                  (sensor) =>
                    sensor.metrics[4] > "25%" && sensor.metrics[4] <= "40%",
                );
                break;
              case "Περίπου στη μέση":
                tempSensors = sensors.filter(
                  (sensor) =>
                    sensor.metrics[4] > "40%" && sensor.metrics[4] <= "60%",
                );
                break;
              case "Σχεδόν πλήρεις":
                tempSensors = sensors.filter(
                  (sensor) =>
                    sensor.metrics[4] > "60%" && sensor.metrics[4] <= "95%",
                );
                break;
              case "Πλήρεις":
                tempSensors = sensors.filter(
                  (sensor) => sensor.metrics[4] > "95%",
                );
                break;
              default:
                tempSensors = [];
                break;
            }
          }
          break;
        }
        case "24": {
          tempSensors = sensors.filter((sensor) => {
            if (filtersVars.length > 1) {
              if (filtersVars.includes("Ελεύθερη")) {
                return (
                  (filtersVars.includes(sensor.type) && !sensor.isOccupied) ??
                  sensor.isOccupied === false
                );
              }
              if (filtersVars.includes("Κατειλημμένη")) {
                return (
                  (filtersVars.includes(sensor.type) && sensor.isOccupied) ??
                  sensor.isOccupied === true
                );
              }
              return filtersVars.includes(sensor.type);
            } else {
              if (filtersVars.includes("Ελεύθερη")) {
                return !sensor.isOccupied ?? null;
              }
              if (filtersVars.includes("Κατειλημμένη")) {
                return sensor.isOccupied ?? null;
              }
              return filtersVars.includes(sensor.type);
            }
          });
          break;
        }
        default: {
          for (let filterVar of filtersVars) {
            tempSensors.filter((sensor) => sensor.metrics.includes(filterVar));
          }
          break;
        }
      }
    }
    setFilteredSensors(
      tempSensors.filter((sensor) => sensor.title !== "Πάτρα Στάθμευση"),
    );
  };

  const getDateString = (interval) => {
    const weekDays = ["Κυρ", "Δευ", "Τρι", "Τετ", "Πεπ", "Παρ", "Σαβ"];
    const fromDate = new Date(interval.from);
    const toDate = new Date(interval.to);
    return `${weekDays[fromDate.getDay()]} ${fromDate.getDate()}/${
      fromDate.getMonth() + 1 < 10
        ? `0${fromDate.getMonth() + 1}`
        : fromDate.getMonth() + 1
    }/${fromDate.getFullYear()} | ${fromDate.getHours()}:${fromDate.getMinutes()} - ${
      toDate.getHours() < 10 ? `0${toDate.getHours()}` : toDate.getHours()
    }:${
      toDate.getMinutes() < 10 ? `0${toDate.getMinutes()}` : toDate.getMinutes()
    }`;
  };

  const handleAddress = (address) => {
    const addressObject = address.toLowerCase().split(" ");
    let tempAddress = "";

    addressObject.forEach(
      (word) =>
        (tempAddress += `${word[0]?.toUpperCase()}${word.slice(
          1,
          word.length,
        )} `),
    );
    return tempAddress;
  };

  // const renderSensorsData = () => {
  //   let tempData = mobilityMap
  //     ? mobility?.mobilityData
  //     : filteredSensors?.length > 1
  //     ? filteredSensors
  //     : sensors;

  //   if (tempData) {
  //     return tempData.map((sensor, id) => {
  //       return (
  //         <SensorItemContainer
  //           style={{
  //             alignItems:
  //               currTypeURL === "1" ||
  //               currTypeURL === "2" ||
  //               currTypeURL === "5"
  //                 ? "flex-start"
  //                 : "center",
  //           }}
  //           key={`sensor_${id}`}
  //           onClick={() => clickMarkHandler(sensor)}
  //         >
  //           <i
  //             className={activeType?.icon}
  //             style={{
  //               fontSize: "32px",
  //               color: activeType?.id === "9" ? "blue" : "inherit",
  //             }}
  //           />
  //           <div
  //             style={{ display: "flex", flexDirection: "column", gap: "4px" }}
  //           >
  //             <p
  //               style={{
  //                 fontSize: "16px",
  //                 fontWeight: "600",
  //               }}
  //             >
  //               {mobilityMap ? sensor.route.title : sensor.title}
  //             </p>
  //             {mobilityMap && (
  //               <p style={{ fontSize: "12px", fontWeight: "600" }}>
  //                 {sensor.route.name}
  //               </p>
  //             )}
  //             <p style={{ fontSize: "14px" }}>
  //               {activeType?.id === "1"
  //                 ? showEnvironmentAddress
  //                   ? handleAddress(sensor.address)
  //                   : null
  //                 : activeType?.id === "24"
  //                 ? mobilityMap
  //                   ? `Μήκος δρόμου: ${sensor.route.length} m`
  //                   : sensor.type ?? sensor.address
  //                 : sensor.address}
  //             </p>
  //             <div
  //               style={{
  //                 display: "flex",
  //                 gap: "4px",
  //                 flexWrap: "wrap",
  //                 paddingTop: "10px",
  //               }}
  //             >
  //               {/* <span style={{ paddingTop: "10px" }}> */}
  //               {(currTypeURL === "1" ||
  //                 currTypeURL === "2" ||
  //                 currTypeURL === "5") &&
  //                 sensor.metrics.map((item, id) => {
  //                   return <img src={item.icon_small} width={30} />;
  //                 })}
  //               {/* </span> */}
  //             </div>
  //             {mobilityMap && (
  //               <>
  //                 <p style={{ fontSize: "14px" }}>
  //                   {getDateString(sensor.interval)}
  //                 </p>
  //                 <p style={{ fontSize: "14px" }}>
  //                   Επίπεδο Κυκλοφορίας:{" "}
  //                   {sensor.level === 0
  //                     ? "Πολύ Χαμηλό"
  //                     : sensor.level === 1
  //                     ? "Χαμηλο"
  //                     : sensor.level === 2
  //                     ? "Μέτριο"
  //                     : sensor.level === 3
  //                     ? "Υψηλό"
  //                     : sensor.level === 4
  //                     ? "Πολύ Υψηλό"
  //                     : "Μη Διαθέσιμο"}
  //                 </p>
  //               </>
  //             )}
  //           </div>
  //         </SensorItemContainer>
  //       );
  //     });
  //   }
  //   return null;
  // };

  const clickMarkHandler = (item) => {
    // console.log("Sensor:", item);
    if (item !== selectSubSystem) {
      if (!mobilityMap) {
        variables.setSelectedItem(item);
        // sensorId.set(item.id);
        // history.push(`${pathname}?typeId=${activeType.id}&sensorId=${item.id}`);
        if (currTypeURL !== "31" && currTypeURL !== "32") {
          showAnimation(true);
        }
      } else {
        selectedRoad.set(item);
      }
    } else {
      showAnimation(false);
    }
  };

  const getMapName = () => {
    switch (currTypeURL) {
      case "1":
        return "environmental.title";
      case "2":
        return "mesh.title";
      case "5":
        return "meteo";
      case "6":
        return "hydro.title";
      case "9":
        return "bins.title";
      case "24":
        return "parking.title";
      case "36":
        return "parking.publicTitle";
      case "4":
        return "wifi.title";
      case "32":
        return "crossings.title";
      case "30":
        return "benches.title";
      case "31":
        return "infos.title";
    }
  };

  const renderAddress = (address) => {
    if (address === "test") return;
    const splitted = address.toLowerCase().split(" ");
    let tempAddress = "";

    splitted.forEach((word) => {
      tempAddress += `${word[0]?.toUpperCase()}${word.slice(1, word.length)} `;
    });
    return tempAddress;
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor:
            currTypeURL === "24" || currTypeURL === "36"
              ? "#CB6DE9"
              : currTypeURL === "9"
              ? "#179D00"
              : currentData?.[0]?.sensortype_color ?? "#F5F5F5",
        }}
      >
        <span style={{ fontSize: "20px" }}>
          {renderAddress(t(getMapName()))}
        </span>
      </div>
      {currTypeURL === "24" &&
        !showMobility &&
        currentData?.map((item, id) => {
          return (
            <ListItem
              key={`${currTypeURL}_list_item_${id}`}
              onClick={() => clickMarkHandler(item)}
            >
              <i
                style={{ fontSize: "32px" }}
                className="im im im im-icon-Car-2"
              ></i>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  width: "90%",
                  margin: "0 auto",
                }}
                key={item.id}
              >
                <div style={{ fontWeight: "600" }}>
                  {item.LabelOnStreet ?? "test"}
                </div>
                <div style={{ fontSize: "14px", fontWeight: "400" }}>
                  {item.Type}
                </div>
              </div>
            </ListItem>
          );
        })}

      {currTypeURL === "24" &&
        showMobility &&
        mobilityData?.map((item, id) => {
          return (
            <ListItem key={`${currTypeURL}_mobility_item_${id}`}>
              <i
                style={{ fontSize: "32px" }}
                className="im im im im-icon-Car-2"
              ></i>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2px",
                  width: "90%",
                  margin: "0 auto",
                }}
                key={item.id}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    width: "250px",
                  }}
                >
                  {item.route.title ?? item.title}
                </div>
                <div style={{ fontSize: "12px", fontWeight: "600" }}>
                  {item.route.name}
                </div>
                <div style={{ fontSize: "14px" }}>
                  {`Μήκος δρόμου: ${item.route.length} m`}
                </div>
                <div style={{ fontSize: "14px" }}>
                  {getDateString(item.interval)}
                </div>
                <div style={{ fontSize: "14px" }}>
                  Επίπεδο Κυκλοφορίας:{" "}
                  {item.level === 0
                    ? "Πολύ Χαμηλό"
                    : item.level === 1
                    ? "Χαμηλο"
                    : item.level === 2
                    ? "Μέτριο"
                    : item.level === 3
                    ? "Υψηλό"
                    : item.level === 4
                    ? "Πολύ Υψηλό"
                    : "Μη Διαθέσιμο"}
                </div>
              </div>
            </ListItem>
          );
        })}

      {currTypeURL !== "24" &&
        currentData?.map((item) => {
          return (
            <ListItem
              key={`${currTypeURL}_${item.ref_id}`}
              onClick={() => clickMarkHandler(item)}
            >
              {currTypeURL === "9" && (
                <img
                  width={70}
                  style={{ marginTop: "-30px" }}
                  src={
                    item.value > "70"
                      ? SvgRecycleBinFull
                      : item.value > "30"
                      ? SvgRecycleBinLow
                      : SvgRecycleBinEmpty
                  }
                />
              )}
              {currTypeURL !== "9" && (
                <i
                  style={{ fontSize: "32px" }}
                  className={`im im im ${
                    currTypeURL === "1"
                      ? "im-icon-Globe"
                      : currTypeURL === "2"
                      ? "im-icon-Business-Mens"
                      : currTypeURL === "4"
                      ? "im-icon-Wifi"
                      : currTypeURL === "5"
                      ? "im-icon-Cloud-Sun"
                      : currTypeURL === "6"
                      ? "im-icon-Drop"
                      : currTypeURL === "30"
                      ? "im-icon-Battery-Charge"
                      : currTypeURL === "31"
                      ? "im-icon-Monitor-Vertical"
                      : currTypeURL === "32"
                      ? "im-icon-Traffic-Light2"
                      : currTypeURL === "36"
                      ? "im-icon-Car-2"
                      : ""
                  }`}
                ></i>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  width: "90%",
                  margin: "0 auto",
                }}
                key={item.ref_id}
              >
                <div style={{ fontWeight: "600", width: "90%" }}>
                  {currTypeURL === "9" && item.address}
                  {currTypeURL !== "9" && item.mysensor_name}
                </div>
                {currTypeURL !== "9" && (
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      width: currTypeURL === "2" ? "80%" : "90%",
                    }}
                  >
                    {renderAddress(
                      item.sensor_address ?? item.address ?? "test",
                    )}
                  </div>
                )}
                {currTypeURL === "9" && (
                  <div>
                    Πληρότητα Κάδου:{" "}
                    <span style={{ fontWeight: "550" }}>{item.value}%</span>
                  </div>
                )}
                
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "2px",
                    flexWrap: "wrap",
                    width: "90%",
                  }}
                >
                  {currTypeURL === "1" ||
                  currTypeURL === "2" ||
                  currTypeURL === "5"
                    ? item.details?.map((sensor, sensorId) => {
                        return (
                          <div key={`${currTypeURL}_sensor_icon_${sensorId}`}>
                            {!sensor.sensorvar_icon.includes("unknown") && (
                              <img
                                src={`https://volos.smartiscity.gr/gallery/vars/Small/${sensor.sensorvar_icon}`}
                                alt="icon"
                                style={{
                                  width: "28px",
                                  height: "28px",
                                  objectFit: "fill",
                                }}
                              />
                            )}
                          </div>
                        );
                      })
                    : null}
                </div>
              </div>
            </ListItem>
          );
        })}
    </div>
  );

  // useEffect(() => {
  //   if (search !== "") {
  //     const currTypeURL = new URLSearchParams(search).get("typeId");
  //     const currSensorURL = new URLSearchParams(search).get("sensorId");

  //     const tempTypeIdActive = state.types.filter(
  //       (item) => item.id === currTypeURL
  //     );

  //     if (tempTypeIdActive.length > 0 && state.sensors.length > 0) {
  //       console.log(tempTypeIdActive, state.sensors);

  //       const data = state.sensors.filter(
  //         (item) => item.typeId === tempTypeIdActive[0].id
  //       );

  //       let activeSensor = "";
  //       let iconsEachSensor = {};
  //       for (let i = 0; i < data.length; i++) {
  //         if (sensorId && data[i].id?.toString() === sensorId) {
  //           activeSensor = data[i];
  //         }
  //         iconsEachSensor = {
  //           ...iconsEachSensor,
  //           [data[i].id]: data[i].metrics.map((metric) => metric.icon_small),
  //         };
  //       }
  //       console.log(state.sensors);
  //       console.log(data);
  //       setActiveType(tempTypeIdActive[0]);
  //       setSensors(data);
  //       console.log(iconsEachSensor);
  //       setIcons(iconsEachSensor);
  //       setSelectSubSystem(activeSensor);
  //     }
  //   }
  // }, [search, state.sensors, state.types]);

  // console.log(selectSubSystem);
};

export default SubSystemList;

const SensorItemContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 20px;

  padding: 20px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 14px;
  width: 100%;
  margin: 0 auto;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  padding: 20px;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
  }
`;
